import 'reakit/styled';
import { palette } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import _get from 'lodash/get';
import space from '../styled/space.js';
import '../styled/index.js';
import { a as _objectSpread } from '../chunk-ad6ad343.js';

var Table = function Table(overrides) {
  return _objectSpread({
    borderColor: palette('white900'),
    spacing: space(2)
  }, _get(overrides, 'Table', {}), {
    hover: _objectSpread({
      backgroundColor: palette('white700')
    }, _get(overrides, 'Table.hover', {})),
    striped: _objectSpread({
      backgroundColor: palette('white600')
    }, _get(overrides, 'Table.striped', {}))
  });
};

export default Table;